import { fetchUserStatus } from "components/Thunks/initAuth";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { router } from "routes";
import { AppDispatch } from "store";

import { MoneyLoading } from "components/routers/MoneyLoading";
import { useHealthQuery } from "components/Slices/usersApiSlice";
import { useInactivityTimeout } from "hooks/useInactivityTimeout";

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading } = useHealthQuery();

  useInactivityTimeout();

  useEffect(() => {
    dispatch(fetchUserStatus());
  }, []);

  if (isLoading) return <MoneyLoading />;
  // if (data?.status != "ok") return <ErrorDisplay />;

  return <RouterProvider router={router} />;
}

export default App;
